import isInstanceReduxUtil from 'modules/redux/utils/is-instance'

/**
 * Checks whether the given `value` is a pointer.
 * @param   {Object}  value
 * @returns {boolean}
 */
function isPointerReduxUtil (value) {
  return (
    !isInstanceReduxUtil(value) &&
    typeof value.className !== 'undefined' &&
    typeof value.data !== 'undefined'
  )
}

export default isPointerReduxUtil
